import React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import Solutions from '../components/Solutions';
import Services from '../components/Services';
import About from '../components/About';
import Contact from '../components/Contact';

const HomePage = () => (
  <Layout>
    <Hero />
    <Solutions />
    <Services />
    <About />
    <Contact />
  </Layout>
);

export default HomePage;
